import { Tabs, Divider } from 'antd';
import constants from '../../constants/constants';
import { SettingOutlined, CarryOutOutlined, ProfileOutlined } from '@ant-design/icons';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { useContext, useEffect } from 'react';
import { CommonContext } from '../../Context';
import SocialMediaPromo from '../SocialMediaPromo';
import SocialReports from './SocialReports';
const { TabPane } = Tabs;

const SocialContainer = () => {

	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	
	useEffect(() => {
		trackPageAccess(buyerId,window.location.href)
	}, []);

	//Render
	return (
		<div>
			<div className='uppercase font-bold text-xl'>Social Media</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="1">
			<TabPane
				tab={ <span className='uppercase'><SettingOutlined className='text-xl' />{constants.SocialTab1}</span> }
				key={1}
			>
				<SocialMediaPromo/>
			</TabPane>
			<TabPane
				tab={ <span className='uppercase'><CarryOutOutlined className='text-xl' />{constants.SocialTab2}</span> }
				key={2}
			>
				<SocialReports/>
			</TabPane>
			</Tabs>
		</div>
	);
};
export default SocialContainer;
